import { LatLngExpression } from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

interface IMapViewController {
  center: LatLngExpression;
  zoom: number | null;
  onViewApplied: () => void;
}

const MapViewController: React.FC<IMapViewController> = ({
  center,
  zoom,
  onViewApplied,
}) => {
  const map = useMap();

  useEffect(() => {
    if (zoom !== null) {
      map.flyTo(center, zoom, {
        animate: true,
        duration: 1,
      });
      onViewApplied(); // Reset zoom back to null after flyTo
    }
  }, [center, zoom, map]);

  return null;
};

export default MapViewController;
